/* eslint-disable react-refresh/only-export-components -- Context and its hook share the invite-flow state contract. */
import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';
import { isAxiosError } from 'axios';
import type { OtpRateLimitState } from '@bvengineering/cas-member-gateway-service-client';
import { getBlockedDeadline } from '@/utils/inviteLockout';

interface InviteAuthState {
  blockedUntil?: number;
  clearBlocked: () => void;
  handleBlockedError: (error: unknown) => boolean;
}

const InviteAuthContext = createContext<InviteAuthState | null>(null);

export function InviteAuthProvider({ children }: { children: ReactNode }) {
  const [blockedUntil, setBlockedUntil] = useState<number>();

  const handleBlockedError = (error: unknown) => {
    if (!isAxiosError<OtpRateLimitState>(error) || !error.response) return false;
    try {
      const deadline = getBlockedDeadline(error.response.status, error.response.data);
      if (deadline === undefined) return false;
      setBlockedUntil(deadline);
      return true;
    } catch {
      // Invalid API duration stays in the caller's ordinary error flow; no invented timer.
      return false;
    }
  };

  return (
    <InviteAuthContext.Provider
      value={{ blockedUntil, handleBlockedError, clearBlocked: () => setBlockedUntil(undefined) }}
    >
      {children}
    </InviteAuthContext.Provider>
  );
}

export function useInviteAuth() {
  return useContext(InviteAuthContext);
}
